module.exports = __webpack_public_path__ + "static/media/ro2.de152fee.jpg";